import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Container,
  Row,
  Col
} from "reactstrap";

class TimelineHeader extends React.Component {

  onHomeCliecked = e => {
    e.preventDefault()
    this.props.history.push("/admin/publicacoes");
  }

  render() {
    return (
      <>
        <div className="header bg-transparent pb-0">
          <Container fluid>
            <div className="header-body">
            </div>
          </Container>
        </div>
      </>
    );
  }
}

TimelineHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string
};

export default TimelineHeader;
